export default __webpack_public_path__ + "static/media/queue.d44753c4.svg";